"use strict";
const Signal = require('./Signal.js');

function SUM(a, b) {
    return a+b;
}

class ManchesterSignal extends Signal {
    constructor(opts) {
        super(opts);
        this._manchesterUnit = opts.manchesterUnit;
        this._manchesterMaxInterval = ((opts.manchesterMaxUnits || 10)+.5)*this._manchesterUnit;
        if(opts.toggleIndexes) {
            let toggleSof = this._sof.slice();
            opts.toggleIndexes.forEach((index) => {
                if(index >= toggleSof.length) return;
                toggleSof[index] = (toggleSof[index]+1)%2;
            });
            this._toggleSof = toggleSof || [];
        }
        this._calculateMaxDataLength();
    }

    _calculateMaxDataLength() {
        this._maxDataLength = this._manchesterMaxInterval;
    }

    _postProcessData(data) {
        if(!this._manchesterUnit) return super._postProcessData(data);
        let result = [];
        let i = 0;
        while(i < data.length) {
            let newI = data.indexOf((data[i]+1) % 2, i);
            if(newI === -1) newI = data.length;
            result.push((newI-i)*this._manchesterUnit);
            i = newI;
        }
        if(result.length % 2 === 0) result.pop();
        return super._postProcessData(result);
    }

    _scoreMatch(data, ref, user, skip) {
        if(!this._manchesterUnit) return super._scoreMatch(data, ref, user, skip);
        return ManchesterSignal.scoreManchesterMatch(data, ref, user, skip, this._manchesterUnit, this._manchesterMaxInterval);
    }

    static scoreManchesterMatch(data, ref, user, skip, unit, maxInterval) {
        if(ref.length === 0) throw new Error("invalid_ref");
        skip = skip || 0;
        let mismatch = 1;
        let j = 0, i = 0;
        let left = 0, right = skip;

        while( i < ref.length && j < data.length && isFinite(mismatch)) {
            if(data[j] > maxInterval) { mismatch = Infinity; }
            let currentState = ((data.length-j+1) % 2);
            let available = data[j]-right;
            let required = unit-left;

            let step = Math.min(available, required);

            if(ref[i] != currentState) mismatch += step;
            left += step;
            right += step;
            if(left > 0.95*unit) {
                i++;
                left = 0;
            }
            if(data[j]-right < 0.05*unit) {
                j++;
                right = 0;
            }
        }

        if(right < 0.5*unit) right = 0; //sync clock left
        if((data[j]-right) < 0.5*unit ) { right = 0; j++; } //sync clock right

        if(right) {
            //sync clock middle
            let units = Math.round(data[j]/unit);
            let taken = Math.round(right/unit);
            if(units == taken) {right = 0; j++; }
            else right = data[j]*(taken/units);
        }


        //if(i < ref.length) mismatch += ref.slice(i).length * unit;
        let duration = data.slice(0,j).reduce(SUM,0)+(right ? data[j]-right : 0)-skip;
        let score = mismatch/duration;
        //score = score * Math.max(1, ref.length/5); //decrease sensitivity for longer references
        score = Math.min(score, 1);

        let result = {
            exthausted: i < ref.length,
            score: score,
            length: j,
            ref: ref,
            user: user,
            skip: right,
        };
        //console.log('res', result, ref, j, data.slice(0,10));
        return result;
    }

}

module.exports = ManchesterSignal;
